module.exports = __webpack_public_path__ + "media/application/images/ui/star-b42d11c3b6d763741b161eaeba6d7b76.png";